import { render, staticRenderFns } from "./RuleModal.vue?vue&type=template&id=7160f9f2"
import script from "./RuleModal.vue?vue&type=script&lang=js"
export * from "./RuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports